export default __webpack_public_path__ + "static/media/extension_giftcard_silver_w4.30b18499.svg";